import TimezoneIOSList from "./timezoneIOSList";

export const getTimeZoneSelectedKey = (timeZone: string) =>
  Object.keys(TimezoneIOSList).find((key) => TimezoneIOSList[key] === timeZone);
